import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import Field from 'Component/Field';
import Form from 'Component/Form';
import Loader from 'Component/Loader';
import ReCAPTCHA from "react-google-recaptcha";
import './ContactUs.style';


export default class ContactUsComponent extends PureComponent{
    static propTypes = {
        onFormSubmit : PropTypes.func.isRequired,
        onFormSubmitSuccess : PropTypes.func.isRequired,
        onFormSubmitFailure : PropTypes.func.isRequired
    }

    onChange(value) {
        this.props.setCaptchaValidation(value)
    }

    renderForm(){
        let {
            onFormSubmit,
            onFormSubmitSuccess,
            onFormSubmitFailure,
            firstname,
            lastname,
            email,
            telephone,
            message,
            contactUsRecipientsFormatted,
            countriesFormatted,
            recaptcha_public_key,
            recaptcha_frontend_enabled,
            recaptcha_frontend_enabled_contact,
            recaptchaRef,
            isSubmitted
        } = this.props;
        if(!contactUsRecipientsFormatted.length)
            return null;

        return(
            <div id="mageguide-contact-us" className="contact-form">
                <Form
                    key="contact-us"
                    onSubmit={ onFormSubmit }
                    onSubmitSuccess={ onFormSubmitSuccess }
                    onSubmitError={ onFormSubmitFailure }
                >
                    <fieldset block="ContactUs" elem="Legend" className="MyAccountOverlay">
                        <div className="inputbox-row-top">
                            <div className="inputbox">
                                <Field
                                    type="text"
                                    label={ __('First name') }
                                    value={firstname}
                                    id="firstname"
                                    name="firstname"
                                    validation={ ['notEmpty'] }
                                />
                            </div>
                            <div className="inputbox">
                                <Field
                                    type="text"
                                    label={ __('Last name') }
                                    value={lastname}
                                    id="lastname"
                                    name="lastname"
                                    validation={ ['notEmpty'] }
                                />
                            </div>
                            <div className="inputbox">
                                <Field
                                    type="text"
                                    label={ __('Email') }
                                    value={email}
                                    id="email"
                                    name="email"
                                    placeholder="example@gmail.com"
                                    validation={ ['notEmpty', 'email'] }
                                />
                            </div>
                        </div>
                        <div className="inputbox-row-bottom">
                            <div className="inputbox-row">
                                <div className="inputbox">
                                    <Field
                                        type="telephone"
                                        name="telephone"
                                        label={ __('Telephone') }
                                        value={telephone}
                                        isSubmitted={isSubmitted}
                                        id="telephone"
                                        name="telephone"
                                    />
                                </div>
                                {
                                    contactUsRecipientsFormatted.length ?
                                        <div className="inputbox">
                                            <Field
                                                isNotSorted={true}
                                                type="select"
                                                label={ __('Subject') }
                                                id="recipient_code"
                                                selectOptions={ contactUsRecipientsFormatted }
                                                name="recipient_code"
                                            />
                                        </div>
                                        :
                                        <div className="inputbox hidden" style={{display:'none'}}>
                                            <Field
                                                type="text"
                                                label={ __('Subject') }
                                                id="recipient_code"
                                                value="default"
                                                name="recipient_code"
                                            />
                                        </div>
                                }
                                {/*{*/}
                                {/*    countriesFormatted.length ?*/}
                                {/*        <div className="inputbox">*/}
                                {/*            <Field*/}
                                {/*                isNotSorted={true}*/}
                                {/*                type="select"*/}
                                {/*                label={ __('Country') }*/}
                                {/*                id="country"*/}
                                {/*                selectOptions={ countriesFormatted }*/}
                                {/*                name="country"*/}
                                {/*            />*/}
                                {/*        </div>*/}
                                {/*        :*/}
                                {/*        ""*/}
                                {/*}*/}
                            </div>
                            <div className="inputbox">
                                <Field
                                    type="textarea"
                                    label={ __('Message') }
                                    value={message}
                                    id="message"
                                    name="message"
                                    validation={ ['notEmpty'] }
                                />
                            </div>
                        </div>
                        {/*<div className="inputbox">*/}
                        {/*    <Field*/}
                        {/*        type="checkbox"*/}
                        {/*        label={ __('The information you provide hereinabove is necessary to process your request and answer your questions. For more information about the processing of your personal data and to know your rights, please consult our Privacy Policy.') }*/}
                        {/*        id="privacy_policy"*/}
                        {/*        name="privacy_policy"*/}
                        {/*        validation={ ['isChecked'] }*/}
                        {/*    />*/}
                        {/*</div>*/}
                        <div className="inputbox-row-right">
                            {
                                recaptcha_public_key && recaptcha_frontend_enabled_contact && recaptcha_frontend_enabled ?
                                <ReCAPTCHA
                                    ref={recaptchaRef}
                                    size="normal"
                                    className="g-recaptcha"
                                    sitekey={recaptcha_public_key}
                                    onChange={this.onChange.bind(this)}
                                /> : null
                            }
                        </div>
                        <div className="inputbox-row-right">
                            <div block="ContactUs" elem="Buttons" className="MyAccountOverlay-Buttons">
                                <button
                                    block="Button"
                                    type="submit"
                                >
                                    { __('Submit') }
                                </button>
                            </div>
                        </div>
                    </fieldset>
                </Form>
            </div>
        );
    }

    render() {
        const { isLoading } = this.props;
        return (
            <>
                <Loader isLoading={isLoading} />
                { this.renderForm() }
            </>
        );
    }
}
